// @ts-expect-error Not migrated
import Croppie from 'croppie';
import styled from 'foundations-theming/utils';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThumbnailCropperWrapper = styled.div.withConfig({
  displayName: "ThumbnailCropper__ThumbnailCropperWrapper"
})([".croppie-container{height:", ";width:", ";margin-block-end:", ";.cr-slider-wrap{margin:", " auto;}.cr-slider{input{overflow:hidden;background-color:", ";}&::-webkit-slider-thumb{margin-top:-", ";inline-size:", ";border:1px solid ", ";box-shadow:", ";block-size:", ";background:", ";cursor:pointer;}&::-moz-range-thumb{margin-top:-", ";inline-size:", ";border:1px solid ", ";box-shadow:", ";block-size:", ";background:", ";cursor:pointer;}&::-ms-thumb{margin-top:-", ";inline-size:", ";border:1px solid ", ";box-shadow:", ";block-size:", ";background:", ";cursor:pointer;}&::-webkit-slider-runnable-track{height:", ";background:", ";cursor:pointer;}&::-moz-range-track{height:", ";background:", ";cursor:pointer;}&::-ms-track{height:", ";background:", ";cursor:pointer;}}}"], props => `${props.height}px`, props => props.width ? `${props.width}px` : 'auto', ({
  theme
}) => theme.space['1200'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.color['fill-accent-blue-default'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.boxShadow['100'], ({
  theme
}) => theme.space[500], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.boxShadow['100'], ({
  theme
}) => theme.space[500], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.boxShadow['100'], ({
  theme
}) => theme.space[500], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.space['50'], ({
  theme
}) => theme.color['border-interactive-pressed'], ({
  theme
}) => theme.space['50'], ({
  theme
}) => theme.color['border-interactive-pressed'], ({
  theme
}) => theme.space['50'], ({
  theme
}) => theme.color['border-interactive-pressed']);
export const ThumbnailCropper = /*#__PURE__*/forwardRef(({
  cropWidth,
  cropHeight,
  cropType,
  lowerHelpText,
  previewHeight,
  previewWidth,
  url,
  zoom
}, ref) => {
  const [croppieInstance, setCroppieInstance] = useState();
  const [croppieDOMNode, setCroppieDOMNode] = useState();
  useImperativeHandle(ref, () => ({
    getCroppedImage() {
      return croppieInstance.result({
        type: 'blob',
        size: 'original',
        quality: 1.0,
        circle: false
      });
    }
  }));
  useEffect(() => {
    if (!croppieDOMNode) {
      return;
    }
    setCroppieInstance(new Croppie(croppieDOMNode, {
      viewport: {
        width: cropWidth,
        height: cropHeight,
        type: cropType
      }
    }));
  }, [croppieDOMNode, cropWidth, cropHeight, cropType]);
  useEffect(() => {
    if (croppieInstance && url) {
      croppieInstance.bind({
        url,
        zoom
      });
    }
  }, [url, zoom, croppieInstance]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ThumbnailCropperWrapper, {
      height: previewHeight,
      width: previewWidth,
      children: /*#__PURE__*/_jsx("div", {
        ref: r => {
          setCroppieDOMNode(r);
        }
      })
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: lowerHelpText
    })]
  });
});
export default ThumbnailCropper;